import { Injectable } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';
import { environment } from '../../environments/environment.prod'

@Injectable({
    providedIn: 'root',
  })

  export class Logger {
    //a variable that controls whether to log info or not. equivalent of a light switch. 
    private initialized = false;
    
    //Stolen from firebase services. This helps us get the data from localstorage
    FORM_TEMPLATES = "form-templates";
    BUSINESS_NAME = "businessName";
    USER_ID = "userId";
    ARTIST_ID = "artistId";
    USER_EMAIL = "userEmail";
  

    //Config for datadog
    loggerConfig = {
      clientToken: environment.dataDogLoggerConfig.clientToken,
      site: environment.dataDogLoggerConfig.site,
      forwardErrorsToLogs: true,
      sessionSampleRate: 30,
      allowedTracingUrls: [ (url) => { console.log(url); return true; }]
    }

    //gets all relevant logging info
    userId = localStorage.getItem(this.USER_ID);
    userEmail = localStorage.getItem(this.USER_EMAIL);
    artistId = localStorage.getItem(this.ARTIST_ID);
    artistBusinessName = localStorage.getItem(this.BUSINESS_NAME);

    //I put it in an object so that in the future if I had to add any other info, I can just change it here instead of a million places
    defaultLoggerParameters = {
      userId: this.userId,
      userEmail: this.userEmail,
      artistId: this.artistId,
      artistBusinessName: this.artistBusinessName
    }


    constructor() {
      if (!environment.dataDogLoggerConfig) {
        return;
      };
      datadogLogs.init(this.loggerConfig);
      //OK to log
      this.initialized = true;
      
    }
  
    /**
     * Logs info to datadog
     * This and the methods below all share the same pattern. 
     * @param message - String. Error message. Should be short and brief.
     * @param context - Object. Any extra optional info you would like to log to datadog. For example, you can choose to log the appointmentId as well.
     */
    debug(message: string, context?: { [x: string]: any }): void {
      if (this.initialized) {
        datadogLogs.logger.debug(message, {...context, ...this.defaultLoggerParameters});
      }
    }
  
    info(message: string, context?: { [x: string]: any }): void {
      if (this.initialized) {
        datadogLogs.logger.info(message, {...context, ...this.defaultLoggerParameters});
      }
    }
  
    warn(message: string, context?: { [x: string]: any }): void {
      if (this.initialized) {
        datadogLogs.logger.warn(message, {...context, ...this.defaultLoggerParameters});
      }
    }
  
    error(message: string, context?: { [x: string]: any }): void {
      if (this.initialized) {
        datadogLogs.logger.error(message, {...context, ...this.defaultLoggerParameters});
      }
    }

    fatal(message: string, context?: { [x: string]: any }): void {
      if (this.initialized) {
        datadogLogs.logger.error(`FATAL: ${message}`, {...context, ...this.defaultLoggerParameters});
      }
    }
}